import { PageViewLayer } from '@component/dataLayer'
import { pushDataLayer } from '../index'

export default function PageViewDataLayer() {

  return (
    <PageViewLayer
      data={{
        'vertical': 'form',
        'vertical_type': 'form',
        'event': 'page_view',
        'page_type': 'detail'
      }}
    />
  )
}

export const formDataLayer = {
  submitClick(leadGen = false) {
    pushDataLayer({
      'vertical': 'form',
      'vertical_type': leadGen ? 'lead_gen_form' : 'form',
      'page_type': 'detail'
    })

    if (leadGen) {
      pushDataLayer({
        'event': 'analytics_track',
        'event_journey': 'Modal',
        'event_interaction': 'Contact Agent',
        'event_type': 'Email agent success'
      })
    }
  }
}